import React from 'react'
import { useTranslation } from 'react-i18next'
import LinkButton from 'components/share/LinkButton'
import { AutomationId } from 'utils/automationUtil'
import openHelpPage from '../../../../../utils/helpLinkUtil'

/* eslint-disable import/prefer-default-export */
export const VocMessageContent = () => {
  const { t } = useTranslation()
  return (
    <>
      {t('vocComingSoon')}{' '}
      <LinkButton data-testid={AutomationId.link.more} onClick={() => openHelpPage(8258254)}>
        {t('moreThreeDot')}
      </LinkButton>
    </>
  )
}
